export const urlParamReplace = (url: string, porps: any) => {
    const keys = Object.keys(porps);
return keys.reduce((acc,crr)=> acc.replace(`$${crr}`, porps[crr])
, url)
}

